import { Component, Input } from '@angular/core';
import { IMetric, IReviewItem, ISubjectMatch } from '../../driver-background-check.view-models';
import { DriverBackgroundCheckStateService } from '../../driver-background-check-state.service';

@Component({
  selector: 'app-bgc-section-summary',
  templateUrl: './bgc-section-summary.component.html',
  styleUrls: ['./bgc-section-summary.component.scss', '../../driver-background-check.component.scss']
})
export class BgcSectionSummaryComponent {
  @Input() subjectMatch: ISubjectMatch;
  @Input() metrics: IMetric[] = [];
  @Input() itemsRequiringReview: IReviewItem[] = [];
  @Input() sectionNote: string;
  @Input() isExpanded: boolean;

  constructor(public stateService: DriverBackgroundCheckStateService) {}

  trackByMetric(index: number, metric: IMetric): string {
    return metric.label;
  }

  trackByReviewSection(index: number, item: IReviewItem): string {
    return item.section;
  }

  isGoodOutcome(value: string): boolean {
    if (!value) {
      return false;
    }
    const normalized = value.trim().toUpperCase();
    return normalized === 'CLEAR' || normalized === 'ELIGIBLE';
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/driver-background-check/components/bgc-section-summary/bgc-section-summary.component.ts